<template>
  <div class="box box-secondary">
    <div class="box-header with-border">
      <h3 class="box-title"><i class="fa fa-line-chart mr-5"></i>Tamaris Statistik</h3>
    </div>
    <div class="box-body">
      <div class="row">
        <div v-for="tam in this.buildData()" class="col-xs-12 col-md-6 col-lg-4">
          <h4>{{'store_number' | translate}}: {{tam.store_number}}</h4>
          <ul class="list-group">
            <li class="list-group-item"><b>{{'name' | translate}}: </b><span class="pull-right"> {{tam.name}}</span></li>
            <li class="list-group-item"><b>{{'submitted_gtins' | translate}}: </b><span class="pull-right">{{tam.count}}</span></li>
            <li class="list-group-item"><b>{{'date' | translate}}: </b><span class="pull-right">{{tam.date}}</span></li>
          </ul>
        </div>
      </div>
      </div>
  </div>

</template>
<script>
  export default {
    props: ['tamaris', 'stores'],
    data() {
      return {
        list: []
      }
    },
    methods: {
      findStoreByStoreNumber: function (storenumber) {
        for (let i = 0; i < this.stores.length; i++) {
          if (this.stores[i].store_number == storenumber) {
            return this.stores[i];
          }
        }
      },
      buildData: function () {
        let result = []
        if (this.tamaris !== 'undefined') {
          this.tamaris.forEach(element => {
            let ent = this.findStoreByStoreNumber(element.store)
            let tmp = {
              store_number: element.store,
              name: ent.name,
              count: element.count,
              date: element.date
            }
            result.push(tmp)
          })
          return result
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/tools/TamarisReport.vue